import GroupPlanBenefits from './group-plan-benefits'

export default GroupPlanBenefits
